import {
  ImApplication,
  CatalogSlumpsResponse,
  ImSpacing,
  ImUnloadTime,
  ImUnloadType,
  ImSlump,
  ImLoadSize,
  ImPumpCapacity,
} from '@cemex-core/cmx-api';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { SingleCatalogsActions, SingleCatalogsActionTypes } from '../actions/single-catalogs.actions';
import { ImFeature } from '@cemex-core/cmx-api/models/catalogs/catalogs-response';

export interface SingleCatalogsState {
  loading: boolean;
  applications: ImApplication[];
  spacings: ImSpacing[];
  localSpacings: ImSpacing[];
  filterSpacings: ImSpacing[];
  unloadTimes: ImUnloadTime[];
  localUnloadTime: ImUnloadTime[];
  filteredUnloadTimes: ImUnloadTime[];
  unloadTypes: ImUnloadType[];
  filteredUnloadTypes: ImUnloadType[];
  slumps: ImSlump[];
  temperatures: any[];
  localTemperatures: ImFeature[];
  filteredSlumps: ImSlump[];
  slumpProduct: {
    [productCode: string]: CatalogSlumpsResponse;
  };
  pumpCapacities: ImPumpCapacity[];
  pumpabilities: {
    id: number;
    name: string;
  }[];
  filteredPumpability: {
    id: number;
    name: string;
  }[];
  loadSizes: ImLoadSize[];
  error: any;
}

export const initialState: SingleCatalogsState = {
  loading: false,
  applications: [],
  spacings: [],
  localSpacings: [],
  filterSpacings: [],
  unloadTimes: [],
  localUnloadTime: [],
  filteredUnloadTimes: [],
  unloadTypes: [],
  filteredUnloadTypes: [],
  slumps: [],
  temperatures: [],
  localTemperatures: [],
  filteredSlumps: [],
  pumpCapacities: [],
  pumpabilities: [
    {
      id: 0,
      name: `0`,
    },
    {
      id: 1,
      name: `1`,
    },
    {
      id: 2,
      name: `2`,
    },
    {
      id: 3,
      name: `3`,
    },
  ],
  filteredPumpability: [
    {
      id: 0,
      name: `0`,
    },
    {
      id: 1,
      name: `1`,
    },
    {
      id: 2,
      name: `2`,
    },
    {
      id: 3,
      name: `3`,
    },
  ],
  slumpProduct: null,
  loadSizes: [],
  error: null,
};

export function reducer(
  state = initialState,
  action: SingleCatalogsActions | OrderBuilderActions,
): SingleCatalogsState {
  switch (action.type) {
    case SingleCatalogsActionTypes.LOAD_APPLICATION: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_APPLICATION_COMPLETED: {
      return {
        ...state,
        applications: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_PUMP_CAPACITY_SUCCESS: {
      return {
        ...state,
        pumpCapacities: action.payload.pumpCapacities,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.ADD_APPLICATION: {
      const applications = action.payload != null ? state.applications.concat(action.payload) : state.unloadTypes;
      return {
        ...state,
        applications: applications,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_SPACING: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_SPACING_COMPLETED: {
      return {
        ...state,
        spacings: action.payload,
        filterSpacings: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.ADD_LOCAL_SPACINGS: {
      const newArray = state.localSpacings.concat(action.payload);
      return {
        ...state,
        localSpacings: newArray,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.ADD_LOCAL_UNLOAD_TIME: {
      const newArray = state.localUnloadTime.concat(action.payload);
      return {
        ...state,
        localUnloadTime: newArray,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.CHANGE_UNLOAD_TIME_COMPLETE: {
      return {
        ...state,
        filterSpacings: action.payload,
      };
    }
    case SingleCatalogsActionTypes.LOAD_UNLOAD_TIME: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_UNLOAD_TIME_COMPLETED: {
      return {
        ...state,
        unloadTimes: action.payload.unloadTimes,
        filteredUnloadTimes:
          action.payload.filteredUnloadTimes && action.payload.filteredUnloadTimes.length > 0
            ? action.payload.filteredUnloadTimes
            : action.payload.unloadTimes,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_UNLOAD_TIME_FILTERED_COMPLETED: {
      return {
        ...state,
        filteredUnloadTimes: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_UNLOAD_TYPE: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_PUMP_CAPACITY: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.ADD_UNLOAD_TYPE: {
      const unloadtypes = action.payload != null ? state.unloadTypes.concat(action.payload) : state.unloadTypes;
      return {
        ...state,
        unloadTypes: unloadtypes,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_UNLOAD_TYPE_COMPLETED: {
      return {
        ...state,
        unloadTypes: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_UNLOAD_TYPE_FILTERED: {
      return {
        ...state,
        filteredUnloadTypes: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_SLUMP: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_SLUMP_COMPLETED: {
      return {
        ...state,
        slumps: action.payload,
        filteredSlumps: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_SLUMP_PRODUCT: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_SLUMP_PRODUCT_COMPLETED: {
      return {
        ...state,
        slumpProduct: {
          ...state.slumpProduct,
          ...action.payload,
        },
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_PUMPABILITIES: {
      return {
        ...state,
        pumpabilities: initialState.pumpabilities,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_PUMPABILITY_FILTERED: {
      return {
        ...state,
        filteredPumpability: action.payload,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_LOAD_SIZE: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_LOAD_SIZE_COMPLETED: {
      return {
        ...state,
        loadSizes: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_TEMPERATURE: {
      return {
        ...state,
        loading: true,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.LOAD_TEMPERATURE_COMPLETED: {
      return {
        ...state,
        temperatures: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.ADD_LOCAL_TEMPERATURE: {
      return {
        ...state,
        localTemperatures: action.payload,
        loading: false,
        error: null,
      } as SingleCatalogsState;
    }
    case SingleCatalogsActionTypes.ERROR: {
      return {
        ...initialState,
        error: action.payload,
      };
    }
    case RESET_BUILDER:
    case SingleCatalogsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case SingleCatalogsActionTypes.UPDATE_LOAD_SIZES: {
      return {
        ...state,
        loadSizes: action.payload,
      };
    }
    case SingleCatalogsActionTypes.RESET_LOAD_SIZES: {
      console.log('Resetting load sizes to initial state');
      return {
        ...state,
        loadSizes: initialState.loadSizes,
      };
    }
    default: {
      return state;
    }
  }
}
